import { render } from "./PageListarCalculoMedia.vue?vue&type=template&id=ca2ea55c"
import script from "./PageListarCalculoMedia.vue?vue&type=script&lang=js"
export * from "./PageListarCalculoMedia.vue?vue&type=script&lang=js"

import "./PageListarCalculoMedia.vue?vue&type=style&index=0&id=ca2ea55c&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__